export default "__VITE_ASSET__Dmul_oZh__"